<div class="top_notification" *ngIf="notification.id">
	<a href="{{notification.attributeLink}}" target="_blank"><p>{{notification.attributeValue}}</p></a>
	<button (click)="close()">
		<span class="material-symbols-outlined">
			close
		</span>
	</button>
</div>

